<template>
	<div class="detail-view grow-with-me">
		<grow-with-me-page></grow-with-me-page>
	</div>
</template>

<script>
import GrowWithMePage from "../components/pages/GrowWithMePage";
import { inject } from "vue";
export default {
  name: "GrowWithMe",
  components: {GrowWithMePage},
  setup() {
    const store = inject("store");
    return {
			actions: store.actions
    };
  },

}
</script>

<style lang="scss">
// .detail-view {
//   &.grow-with-me {
//     .product-detail {
//       top: 25vh;
//       left: 0;
//       right: 0;
//       margin: 0 auto;
//     }
//   }
// }

</style>
